import React from 'react';

import { is } from '../../utils';

import Form from '../Form';
import FormField from '../FormField';
import FormFooter from '../FormFooter';

import PasswordResetLayout from './PasswordResetLayout';

const initialValues = {
  email: '',
};

function validate({ email }) {
  const errors = {};
  if (is.empty(email)) {
    errors.email = i18n.gettext('Please provide your email address.');
  } else if (!is.email(email)) {
    errors.email = i18n.gettext('Please provide a valid email address.');
  }
  return errors;
}

function PasswordResetRequestForm() {
  return (
    <PasswordResetLayout>
      <Form initialValues={initialValues} validate={validate}>
        <div style={{ marginBottom: '2rem' }}>
          {i18n.gettext(
            "Enter your email address below, and we'll email instructions for setting a new password for your resmio account."
          )}
        </div>
        <FormField
          name="email"
          placeholder={i18n.gettext('Email address')}
          style={{ marginBottom: '2rem' }}
        />
        <FormFooter submitButtonLabel={i18n.gettext('Reset password')} />
      </Form>
    </PasswordResetLayout>
  );
}

export default PasswordResetRequestForm;
